import BaseTreeView from './BaseTreeView';
import MouvementTreeView from '../mouvements/MouvementTreeView';
import TreeViewType from '../../constants/liquidation/TreeViewType';

class TreeViewFactory {
  static newInstance(type: TreeViewType): BaseTreeView {
    switch (type) {
      case TreeViewType.MOUVEMENT:
        return new MouvementTreeView();
      default:
        return null;
    }
  }
}

export default TreeViewFactory;
